export const passHelpers = {
	// Avatar Functions
	getAvatarMedia: (media = [], targetLocations = ['Square']) => {
		if(!passHelpers.hasAvatarMedia(media, targetLocations)) return false;

		const avatarMedia = [];
		targetLocations.forEach(location => {
			const index = media.findIndex(m => m.location === location);
			if(index > -1) avatarMedia.push(media[index].url);
		});
		return avatarMedia[0];

	},
	hasAvatarMedia: (media = [], targetLocations = ['Square']) =>
			media.length && media.some(m => targetLocations.includes(m.location)),
};
